import { actions } from 'data'
import isEmpty from 'lodash/isEmpty'
import { call, put, takeEvery } from 'redux-saga/effects'

import { getUkFrictionsState } from '../../../services/api/user'

const getUKFrictionsStateSaga = function* (action) {
  const data = yield call(getUkFrictionsState, action.payload)

  const qualifies = !isEmpty(data.response)

  if (!qualifies) {
    yield put(actions.auth.ukFrictions.set(null))
  } else {
    yield put(actions.auth.ukFrictions.set(data.response))
  }
}

export default function* UKFrictionsSagas() {
  yield takeEvery(actions.auth.ukFrictions.fetch.type, getUKFrictionsStateSaga)
}
